import { useUpdateFixtureStaffPersonDc, useUpdateFixtureStaffPersonInternal } from "hooks/useFixtureStaffApi";
import { useUpdateSeasonStaffPersonDc, useUpdateSeasonStaffPersonInternal } from "hooks/useSeasonStaffApi";
import { useCallback, useRef } from "react";

type Props = {
  entityId: string;
  seasonId: string;
  personId?: string;
  dcPersonId?: string;
  data: any;
  record: any;
};

export const useUpdateSeasonStaffPerson = () => {
  const lastUpdateRef = useRef(undefined);
  const {
    isPending: isUpdatingInternalSeasonStaff,
    isSuccess: isSuccessInternalSeasonStaff,
    mutateAsync: updateInternalSeasonStaff,
  } = useUpdateSeasonStaffPersonInternal();
  const {
    isPending: isUpdatingDcSeasonStaff,
    isSuccess: isSuccessDcSeasonStaff,
    mutateAsync: updateDcSeasonStaff,
  } = useUpdateSeasonStaffPersonDc();

  const mutateAsync = useCallback(
    async ({ entityId, seasonId, personId, dcPersonId, data, record }: Props) => {
      lastUpdateRef.current = record;

      if (personId) {
        await updateInternalSeasonStaff({
          entityId,
          seasonId,
          personId: personId || "undefined",
          data,
        });
      } else if (dcPersonId) {
        await updateDcSeasonStaff({
          entityId,
          seasonId,
          dcPersonId: dcPersonId || "undefined",
          data,
        });
      }
    },
    [updateInternalSeasonStaff, updateDcSeasonStaff]
  );

  const isUpdating = isUpdatingInternalSeasonStaff || isUpdatingDcSeasonStaff;

  return {
    updatingRecord: isUpdating ? lastUpdateRef.current : undefined,
    mutateAsync,
    isUpdating,
    isSuccess: isSuccessInternalSeasonStaff && isSuccessDcSeasonStaff,
  };
};

export const useUpdateFixtureStaffPerson = () => {
  const lastUpdateRef = useRef(undefined);
  const {
    isPending: isUpdatingInternalFixtureStaff,
    isSuccess: isSuccessInternalFixtureStaff,
    mutateAsync: updateInternalFixtureStaff,
  } = useUpdateFixtureStaffPersonInternal();
  const {
    isPending: isUpdatingDcFixtureStaff,
    isSuccess: isSuccessDcFixtureStaff,
    mutateAsync: updateDcFixtureStaff,
  } = useUpdateFixtureStaffPersonDc();

  const mutateAsync = useCallback(
    async ({ entityId, seasonId, fixtureId, personId, dcPersonId, data, record }: Props & { fixtureId: string }) => {
      lastUpdateRef.current = record;

      if (personId) {
        await updateInternalFixtureStaff({
          entityId,
          seasonId,
          fixtureId,
          personId: personId || "undefined",
          data,
        });
      } else if (dcPersonId) {
        await updateDcFixtureStaff({
          entityId,
          seasonId,
          fixtureId,
          dcPersonId: dcPersonId || "undefined",
          data,
        });
      }
    },
    [updateInternalFixtureStaff, updateDcFixtureStaff]
  );

  const isUpdating = isUpdatingInternalFixtureStaff || isUpdatingDcFixtureStaff;

  return {
    updatingRecord: isUpdating ? lastUpdateRef.current : undefined,
    mutateAsync,
    isUpdating,
    isSuccess: isSuccessInternalFixtureStaff && isSuccessDcFixtureStaff,
  };
};
